import { ProviderMeta } from '@shared/providers/provider-meta';

const hubspotIdPattern = /^[1-9]\d*$/;

class HubspotMeta implements ProviderMeta {
  getIdFieldLength(): number {
    return 20;
  }
  getIdFieldName(): string {
    return 'hs_object_id';
  }

  getIdFieldlabel(): string {
    return 'record id';
  }

  isIdValue(value: string): boolean {
    return hubspotIdPattern.test(value);
  }
}

export default HubspotMeta;
